export default __webpack_public_path__ + "static/media/featSportMb.55650392.png";